import React from "react";
import {Route} from "react-router-dom";
import {VariationList, ProductShow, ProductList} from "../../views/marketplace/retailer/product/index";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerLoader from "../../hoc/retailer/retailerLoader";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {sessionStore} from "../../utils/sessionStore";
import PimShow from "../../domain/components/products/components/Pim/components/PimShow";
import Pim from "../../domain/components/products/components/Pim/components";

let routes = [];
const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (applications && applications["marketplace"]) {
    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW) || hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)) {
        routes.push([
            <Route
                path="/retailers/show/:id/products/variations/:params"
                component={RequireAuthentication(RetailerLoader(VariationList))}
                exact
                strict
                key="variationList"
            />,
            <Route
                path="/retailers/show/:id/products/:params"
                component={RequireAuthentication(RetailerLoader(ProductList))}
                exact
                strict
                key="list"
            />,
        ])
    }

    // TODO temp
    if (hasAuthorization(authorizations, Authorizations.GLOBAL_DEMO)) {
        routes.push([
            <Route
                path="/retailers/show/:id/pim"
                component={RequireAuthentication(RetailerLoader(Pim))}
                exact
                strict
                key="pim"
            />,
            <Route
                path="/retailers/show/:id/products/pim/:prid"
                component={RequireAuthentication(RetailerLoader(PimShow))}
                exact
                strict
                key="pimshow"
            />,
        ]);
    }

    if (hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)) {
        routes.push([
            <Route
                path="/retailers/show/:id/products/show/:prid"
                component={RequireAuthentication(RetailerLoader(ProductShow))}
                exact
                strict
                key="productShow"
            />,
            <Route
                path="/retailers/show/:id/products/show/:prid/variation/:vrid"
                component={RequireAuthentication(RetailerLoader(ProductShow))}
                exact
                strict
                key="variationShow"
            />,
        ])
    }
}

export default routes;
